import { render, staticRenderFns } from "./DashboardPane.v2.vue?vue&type=template&id=1beb4204&scoped=true"
import script from "./DashboardPane.v2.vue?vue&type=script&lang=js"
export * from "./DashboardPane.v2.vue?vue&type=script&lang=js"
import style0 from "./DashboardPane.v2.vue?vue&type=style&index=0&id=1beb4204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb4204",
  null
  
)

export default component.exports